import {REFERRALS_DEFAULT_CLINIC_ID} from '../actions/Index';

const initState = {
  referralsDefaultClinicId: null,
  referralsDefaultFilters: null
};
export default function (state = initState, action: any): any {
  const {type, payload} = action;
  switch (type) {
    case REFERRALS_DEFAULT_CLINIC_ID:
      return {
        ...state,
        referralsDefaultClinicId: payload.referralsDefaultClinicId,
        referralsDefaultFilters: payload.referralsDefaultFilters
      };
    default:
      return state;
  }
}
